const $ = require('jquery');

export function copyURL() { 
    const $temp = $("<input>");
    const $url = $(location).attr('href');

    $('.clipboard').on('click', function() {
        $("body").append($temp);
        $temp.val($url).select();
        document.execCommand("copy");
        $temp.remove();
        $(".clipboard span").text("URL copied!");
    });
}